/* eslint-disable */
// @ts-nocheck

import React from "react";
import { TextArea } from "@carbon/react";

interface IProps {
  id?: string;
  className?: string;
  labelText?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (value: any) => void;
  value?: string;
  invalid?: boolean;
  invalidText?: string;
}

const CommentField = ({
  id,
  className,
  labelText,
  placeholder,
  disabled = false,
  onChange,
  value,
  invalid = false,
  invalidText,
}: IProps) => {
  return (
    <TextArea
      id={id}
      className={className}
      placeholder={placeholder}
      labelText={labelText}
      value={value}
      disabled={disabled}
      invalid={invalid}
      invalidText={invalidText}
      onChange={(e) => {
        onChange(e);
      }}
      data-cy={`${
        labelText?.replaceAll(" ", "") ?? placeholder?.replaceAll(" ", "")
      }-textarea`}
    />
  );
};
export default CommentField;
